import time from "src/utils/time";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { isFreemium, hasPremium } from "src/modules/auth/duck/selectors";
import SvgContainer from "src/components/SvgContainer";
import { Caption, Subtitle, BodyText2 } from "src/atoms/typography";

import AudioLoader from "src/components/AudioLoader";
import AudioPlayer from "./AudioPlayer";
import { ReactComponent as NoisyIcon } from "src/modules/activity-log/icons/noisy.svg";
import { ReactComponent as PlayIcon } from "./play-circle.svg";

export default function AwakeEvent({
  startTimeColumnWidth,
  avatar,
  eventAudioPlayer,
  activityLogType,
  formattedStartTime,
  event,
  toggleFreemiumFlow,
  freemium
}) {
  const { t } = useTranslation();
  const isFreeVersion = useSelector(isFreemium);
  const isPremiumUser = useSelector(hasPremium);
  const { fileName, fileRelatedDuration, duration } = event;
  const isSelectedAudio =
    eventAudioPlayer && eventAudioPlayer.fileName === fileName?.value;
  const isLoading = isSelectedAudio && eventAudioPlayer.status === "loading";
  const isPlaying = isSelectedAudio && eventAudioPlayer.status === "playing";
  const isResting = !isSelectedAudio;
  let eventText;
  if (activityLogType === "live") {
    if (avatar && avatar.sex === "female") {
      eventText = t("femaleAwake");
    } else eventText = t("maleAwake");
  } else {
    if (avatar) {
      eventText = t(avatar.sex === "male" ? "maleWasAwake" : "femaleWasAwake", {
        value0: avatar.name
      });
    } else eventText = t("avatarWasAwake");
  }

  return (
    <Flex alignItems="center" height="36px">
      {isPlaying && activityLogType === "live" ? null : (
        <>
          <Caption
            textAlign="right"
            mr="16px"
            color="mediumEmphasis"
            width={startTimeColumnWidth + "px"}
            flex="0 0 auto"
          >
            {formattedStartTime}
          </Caption>
          <SvgContainer
            mr="16px"
            fill="warningBase"
            icon={NoisyIcon}
            size="20px"
          />
        </>
      )}
      {isPlaying && (
        <AudioPlayer
          onStop={eventAudioPlayer.stop}
          onSeek={eventAudioPlayer.seek}
          onSeekCommitted={eventAudioPlayer.seekCommitted}
          getDuration={eventAudioPlayer.getDuration}
          getCurrentTime={eventAudioPlayer.getCurrentTime}
          width={activityLogType === "live" ? "100%" : "214px"}
        />
      )}
      {isLoading && <AudioLoader onStop={eventAudioPlayer.stop} />}
      {isResting && (
        <Flex flexDirection="column">
          <Subtitle
            color="highEmphasis"
            maxWidth={activityLogType === "live" ? "96px" : "220px"}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {eventText}
          </Subtitle>
          <Flex alignItems="center" mt="3px">
            {eventAudioPlayer && !(freemium && isPremiumUser) && (
              <SvgContainer
                onClick={() =>
                  isFreeVersion
                    ? toggleFreemiumFlow("soundsAndVideos")
                    : eventAudioPlayer.play(fileName?.value)
                }
                mr="4px"
                size="16px"
                icon={PlayIcon}
                fill="mediumEmphasis"
              />
            )}
            <BodyText2 lineHeight={1} color="mediumEmphasis">
              {time
                .duration(fileRelatedDuration || duration)
                .format("h _ m _ s _")}
            </BodyText2>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
